import { render, staticRenderFns } from "./NumberInputComponent.vue?vue&type=template&id=1f5fdd37&scoped=true&"
import script from "./NumberInputComponent.vue?vue&type=script&lang=js&"
export * from "./NumberInputComponent.vue?vue&type=script&lang=js&"
import style0 from "./NumberInputComponent.vue?vue&type=style&index=0&id=1f5fdd37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5fdd37",
  null
  
)

export default component.exports